import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import * as authApi from '../api/auth'

export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!email.trim()) return

    setError('')
    setLoading(true)
    try {
      await authApi.forgotPassword({ email: email.trim() })
      setSubmitted(true)
    } catch {
      setError('Unable to process your request. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Helmet>
        <title>Forgot Password - ARPU</title>
      </Helmet>

      <div className="max-w-md mx-auto mt-12">
        <h1 className="text-2xl font-heading font-bold text-text mb-2 text-center">
          Reset Your Password
        </h1>

        {submitted ? (
          <div className="bg-success/10 border border-success/30 rounded-lg p-6 text-center">
            <p className="text-text-light mb-4">
              If an account exists with the email <strong className="text-text">{email}</strong>, a password reset link has been sent.
            </p>
            <p className="text-sm text-text-muted mb-6">
              Check your inbox and spam folder. The link expires in 1 hour.
            </p>
            <Link
              to="/login"
              className="inline-block px-6 py-2.5 bg-primary hover:bg-primary-light text-text-inverse font-medium rounded-md transition-colors"
            >
              Back to Login
            </Link>
          </div>
        ) : (
          <>
            <p className="text-text-light text-center mb-6">
              Enter the email address associated with your account and we'll send you a link to reset your password.
            </p>

            {error && (
              <div className="bg-error/10 border border-error/30 text-error rounded-md px-4 py-3 mb-4 text-sm">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-text mb-1">
                  Email Address
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
                />
              </div>
              <button
                type="submit"
                disabled={loading || !email.trim()}
                className="w-full py-2.5 bg-primary hover:bg-primary-light text-text-inverse font-medium rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        )}

        <div className="mt-6 text-center text-sm text-text-muted space-y-2">
          <p>
            <Link to="/login" className="text-primary hover:underline">
              Back to Login
            </Link>
          </p>
          <p>
            Don't have an account?{' '}
            <Link to="/claim" className="text-primary hover:underline">
              Claim your account
            </Link>
            {' or '}
            <Link to="/join" className="text-primary hover:underline">
              Join the AU
            </Link>
          </p>
        </div>
      </div>
    </>
  )
}
